// usePlaces.js
import { ref, computed } from 'vue';
import api from "@/api/api";

const places = ref([]);
const placesLoading = ref(false);
const placesLoaded = ref(false);

const fetchPlaces = async () => {
    if (placesLoaded.value) {
        return;
    }
    placesLoading.value = true;
    try {
        const response = await api.get('/places/');
        places.value = response.data;
        placesLoaded.value = true;
    } catch (error) {
        console.error('Error fetching places:', error);
    } finally {
        placesLoading.value = false;
    }
};

const getPlaceById = (id) => {
    return computed(() => places.value.find(place => place.markerId === id));
};

export default function usePlaces() {
    return { places, fetchPlaces, placesLoading, placesLoaded, getPlaceById };
}
